export default "__VITE_ASSET__BLDWFE_h__"